import { db } from "./db";
import type { Lemonade, Unit } from "./types";

function randomDate(start: Date, end: Date) {
    return new Date(start.getTime() + Math.random() * (end.getTime() - start.getTime()));
}

export async function seedDatabase() {
    // clear existing data
    await db.lemonades.clear();
    await db.sales.clear();
    await db.purchases.clear();

    // example lemonades
    const lemonades: Lemonade[] = [
        {
            name: "Citromos",
            price: 400,
            ingredients: [
                { name: "víz", amount: { amount: 1, unit: "l" } },
                { name: "citrom", amount: { amount: 2.5, unit: "db" } },
                { name: "cukor", amount: { amount: 100, unit: "g" } }
            ]
        },
        {
            name: "Narancsos",
            price: 500,
            ingredients: [
                { name: "víz", amount: { amount: 1, unit: "l" } },
                { name: "narancs", amount: { amount: 2.5, unit: "db" } },
                { name: "cukor", amount: { amount: 100, unit: "g" } }
            ]
        }
    ];

    for (const l of lemonades) {
        await db.addLemonade(l);
    }

    // example purchases
    const products = ["víz", "citrom", "cukor", "narancs"];
    for (let i = 0; i < 20; i++) {
        const product = products[Math.floor(Math.random() * products.length)];
        let unit: Unit;
        if (product === "víz") {
            unit = "l";
        } else if (product === "cukor") {
            unit = "kg";
        } else {
            unit = "db";
        }
        await db.addPurchase({
            date: randomDate(new Date(2024, 4, 1), new Date()),
            product: product,
            amount: {
                amount: Math.round(Math.random() * 10 + 1),
                unit: unit as Unit
            },
            price: Math.round(Math.random() * 1000 + 200)
        });
    }

    // example sales
    for (let i = 0; i < 30; i++) {
        const lemonade = lemonades[Math.floor(Math.random() * lemonades.length)];
        const amount = Math.floor(Math.random() * 5 + 1);
        await db.addSale({
            date: randomDate(new Date(2024, 4, 1), new Date()),
            lemonade,
            amount,
            price: lemonade.price * amount
        });
    }
}

//@ts-ignore
window.funstuff = seedDatabase; // expose for debugging
